import React, { useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { defaultGridHeight } from './utils';
import { useSignificantYoyGrowthContext } from 'contexts/CategoryInsightsKpi/SignificantYoyGrowthProvider';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const SignificantYoyGrowthExplore = () => {
	const { gridData } = useSignificantYoyGrowthContext();
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					<p>Suppliers that meet the below conditions.</p>
					<ol type="1">
						<li>
							1. Supplier spend growth is more than 10% vs category spend growth
							over last 2 years OR
						</li>
						<li>
							2. Supplier spend growth at L4 category level is more than 8% over
							L4 category spend growth over last 2 years
						</li>
					</ol>
				</AnalysisDescription>
				<TableContainer>
					<AgGridTable gridOptions={gridData} gridStyle={gridStyle} />
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default SignificantYoyGrowthExplore;
